import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { FleetListItem, FleetsResponse } from '../types/Fleets';
import { ProfileAPIService } from '../services/AxiosAPIService';
import { logger } from '../services/SharedService';

const FLEETS_QUERY = '?limit=1000&skip=0';

export const getFleets = async (query: string): Promise<FleetListItem[]> => {
  logger.info('GET', 'REQUEST', 'getFleets', `/fleets${query}`);

  const { data } = await ProfileAPIService.api.get<FleetsResponse | FleetListItem[]>(`/fleets${query}`);

  logger.info('GET', 'RESPONSE', 'getFleets', data);
  return Array.isArray(data) ? data : data?.results || [];
};

// only system admins are allowed to list all fleets, thus the query is disabled by default
function useGetFleets(enabled = false): UseQueryResult<FleetListItem[]> {
  return useQuery(
    ['fleets', FLEETS_QUERY],
    async (): Promise<FleetListItem[]> => getFleets(FLEETS_QUERY),
    {
      retry: 1,
      retryDelay: 3000,
      enabled,
      staleTime: 5 * 60 * 1000,
    },
  );
}

export default useGetFleets;
